import { render, staticRenderFns } from "./clockinstatics.vue?vue&type=template&id=60f77a44&scoped=true&"
import script from "./clockinstatics.vue?vue&type=script&lang=js&"
export * from "./clockinstatics.vue?vue&type=script&lang=js&"
import style0 from "./clockinstatics.vue?vue&type=style&index=0&id=60f77a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f77a44",
  null
  
)

export default component.exports